import {
  commonActions,
  commonGetters,
  commonMutations
} from '@/store/store_utils'
import { toCommonInstrumentCode } from '@/utils/measurement_utils'

const dataName = 'laboratoryItems'

const state = {
  laboratoryItems: [],
  updatedAt: '20101010101010'
}

const getters = {
  ...commonGetters(dataName, ['getData', 'getUpdatedAt'], { filterDel: true }),
  getLaboratoryItem: state => (
    masterLaboratoryInstrumentCode,
    masterLaboratoryItemCode
  ) => {
    const commonInstrumentCode = toCommonInstrumentCode(
      masterLaboratoryInstrumentCode
    )
    return state.laboratoryItems.find(item => {
      return (
        item.masterLaboratoryInstrumentCode === commonInstrumentCode &&
        item.masterLaboratoryItemCode === masterLaboratoryItemCode
      )
    })
  },
  getLaboratoryItemsByInstrumentCode: state => masterLaboratoryInstrumentCode => {
    const commonInstrumentCode = toCommonInstrumentCode(
      masterLaboratoryInstrumentCode
    )
    return state.laboratoryItems.filter(
      item => item.masterLaboratoryInstrumentCode === commonInstrumentCode
    )
  }
}

const actions = {
  ...commonActions(['setData', 'setUpdatedAt', 'updateAfter'])
}

const mutations = {
  ...commonMutations(dataName, ['setData', 'setUpdatedAt', 'updateAfter'], {})
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
